import { MbCheckoutBillingService } from '../services/mb-checkout-billing.service'
import { Provider } from '@angular/core'
import { MbCheckoutBillingFacade } from './mb-checkout-billing.facade'
import { MbCheckoutDeliveryFacade } from './mb-checkout-delivery.facade'
import { MbCheckoutDeliveryService } from '../services/mb-checkout-delivery.service'
import { MbCheckoutContactDetailsFacade } from './mb-checkout-contact-details.facade'
import { MbCheckoutContactDetailsService } from '../services/mb-checkout-contact-details.service'
import { MbCheckoutQuoteInfoFacade } from './mb-checkout-quote-info.facade'
import { MbCheckoutQuoteInfoService } from '../services/mb-checkout-quote-info.service'
import { MbCheckoutShippingService } from '../services/mb-checkout-shipping.service'
import { MbCheckoutShippingFacade } from './mb-checkout-shipping.facade'
import { MbOrderService } from '../services/mb-order.service'
import { MbOrderFacade } from './mb-order.facade'

export const mbFacadeProviders: Provider[] = [
  MbCheckoutBillingService,
  {
    provide: MbCheckoutBillingFacade,
    useExisting: MbCheckoutBillingService
  },
  MbCheckoutDeliveryService,
  {
    provide: MbCheckoutDeliveryFacade,
    useExisting: MbCheckoutDeliveryService
  },
  MbCheckoutContactDetailsService,
  {
    provide: MbCheckoutContactDetailsFacade,
    useExisting: MbCheckoutContactDetailsService
  },
  MbCheckoutQuoteInfoService,
  {
    provide: MbCheckoutQuoteInfoFacade,
    useExisting: MbCheckoutQuoteInfoService
  },
  MbCheckoutShippingService,
  {
    provide: MbCheckoutShippingFacade,
    useExisting: MbCheckoutShippingService
  },
  MbOrderService,
  {
    provide: MbOrderFacade,
    useExisting: MbOrderService
  }
]
